export default __webpack_public_path__ + "static/media/alexa1.ac8cb6dc.webp";